import React from 'react';
import { ReactNode } from 'react';
import { Tooltip } from '@mui/material';

interface IMenuItemProps {
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  isCollapsed: boolean;
  onClick: () => void;
  textClassName?: string;
}

const SideNavMenuItem: React.FC<IMenuItemProps> = ({
  icon,
  label,
  isActive = false,
  isCollapsed,
  textClassName,
  onClick,
}) => {
  const menuItem = (
    <div
      className={`flex flex-row cursor-pointer items-center py-3 mt-3 rounded-[4px] transition-colors duration-300 ease-in-out group hover:outline hover:outline-[#8394E3] hover:outline-offset-[2px] hover:bg-blue-950 h-[40px] border-2 border-transparent ${
        isActive
          ? 'bg-ds-mc-blue-100 text-ds-mc-blue-600 hover:text-primary-blue-100 active:bg-blue-2000'
          : 'hover:text-primary-gray-550 text-primary-gray-550'
      } ${isCollapsed ? 'justify-center px-6' : 'px-6'}`}
      onClick={onClick}
    >
      <span className="grow w-[30px]">{icon}</span>
      <span
        data-testid="side-nav-menu-label"
        className={`text-xs grow w-full font-normal whitespace-nowrap overflow-hidden transition-colors duration-300 text-inherit  group-hover:text-inherit group:text-inherit 
        ${isCollapsed ? 'w-0 opacity-0 ml-0' : 'w-auto opacity-100 ml-4'} ${textClassName}`}
      >
        {label}
      </span>
    </div>
  );

  return isCollapsed ? (
    <Tooltip
      title={label}
      placement="right"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: '#4F4F4F',
            color: '#FFFFFF',
            fontSize: '11px',
            fontWeight: 600,
            padding: '4px 8px',
            borderRadius: '2px 0px 0px 0px',
            opacity: 1,
            ['& .MuiTooltip-arrow']: {
              color: '#4F4F4F',
            },
          },
        },
      }}
    >
      {menuItem}
    </Tooltip>
  ) : (
    menuItem
  );
};

export default SideNavMenuItem;
